//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UserDisplayFallback: FeatureFlag = {"Id":"UserDisplayFallback","Label":"[10.23]Show best available user identity","Impact":"Enables the five-tier display-name fallback chain (current IdP claim → stored profile name → current IdP email → stored profile email → configurable fallback label) for header/profile menus, reviewer history, comment authors, and Calculated Display Labels.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
